// Ref: GitHub issue #37, task A2 — route-level code splitting fallback
import React from 'react';

/**
 * PageSkeleton — shown by <Suspense> while a lazy page chunk is loading.
 * Intentionally lightweight: no external deps, no network calls.
 */
export function PageSkeleton() {
  return (
    <div
      role="status"
      aria-label="Loading page"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        width: '100%',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 'var(--space-3)',
        }}
      >
        {/* Spinner ring */}
        <div
          style={{
            width: 40,
            height: 40,
            border: '3px solid var(--color-border)',
            borderTopColor: 'var(--color-primary)',
            borderRadius: '50%',
            animation: 'spin 0.8s linear infinite',
          }}
          aria-hidden="true"
        />
        <span
          style={{
            fontSize: 'var(--text-sm)',
            color: 'var(--color-text-secondary)',
          }}
        >
          Loading…
        </span>
      </div>

      {/* Inline keyframe — avoids an extra CSS import for a one-liner */}
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
